import React from "react";
import { Link } from "react-router-dom";
import WebsiteNavbar from "../components/WebsiteNavbar";
import Footer from "../components/Footer";
import "../style/notFound.css";

const NotFoundPage = () => {
  return (
    <div className="nf-page-wrapper">
      <WebsiteNavbar />
      <main className="nf-container">
        <div className="nf-card">
          <div className="nf-badge">404</div>
          <h1 className="nf-title">Page Not Found</h1>
          <p className="nf-desc">
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </p>
          <div className="nf-actions">
            <Link to="/" className="nf-btn-primary">
              Return Home
            </Link>
            <Link to="/booking" className="nf-btn-secondary">
              Book a Skip Bin
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
